import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const LandingPage = () => {
  return (
    <>
      <div className="setion-wrapper w-100">
        <div className="header-landing w-100">
          <Container>
            <div className="heading-landing p-3 d-flex align-items-center justify-content-between">
              <img src="../assets/images/Logo1.png" alt="" class="img-fluid" />
              <div className="button-head-laindng">
                <Link to="/login">
                  {" "}
                  <Button>Admin Login</Button>
                </Link>
              </div>
            </div>
          </Container>
        </div>
        <div className="content-landing text-center">
          <h2 className="pb-2">AmericanTax Settlement</h2>
          <p>
            American Tax Settlement LLC is a full service Tax Resolution firm
            that can handle almost any IRS or State Tax Issue. Our team is on
            hand to provide answers for clients impacted by garnishments, bank
            levies, liens and other challenges.
          </p>
          <br />
          <p>
            American Tax Settlement LLC is committed to providing a safe and
            secure site that you can trust. We take your privacy seriously and
            will not share your information.
          </p>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
